<template>
    <div class="app-layout">
        <div class="header">
            <div class="meta" :class="'meta--'+layout">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <meta-logo/>
                            <menu-nav/>
                        </div>
                        <div class="col">
                            <meta-nav/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="menu">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <div></div>
                            <menu-actions v-if="isClient"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="main--intro" :class="mainClass" v-if="hasIntro">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <div class="headline">
                                <span class="overline-1">
                                    <slot name="overline"/>
                                </span>
                                <h4>
                                    <slot name="headline"/>
                                </h4>
                            </div>
                        </div>
                        <div class="col col--align-center col--justify-end" v-if="hasStepper">
                            <slot name="stepper"/>
                        </div>
                        <div class="col col--justify-end" v-if="hasProducerOptions">
                            <slot name="produceroptions"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main--intro-nav" v-if="hasIntroNav">
                <div class="container">
                    <slot name="intronav"/>
                </div>
            </div>
            <div class="main--content">
                <div class="container">
                    <slot/>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
import MetaLogo from '@partfactory/Shared/Header/MetaLogo';
import MetaNav from '@partfactory/Shared/Header/MetaNav';
import MenuNav from '@partfactory/Shared/Header/MenuNav';
import MenuActions from '@partfactory/Shared/Header/MenuActions';

export default {
    name: 'AppLayout',
    components: {
        MenuActions,
        MenuNav,
        MetaNav,
        MetaLogo
    },
    props: {
        displayMode: null,
    },
    computed: {
        layout() {
            return this.$page.props.routePrefix;
        },
        isClient() {
            return this.$page.props.routePrefix === 'client';
        },
        hasIntro() {
            return !!(this.$slots.overline || this.$slots.headline || this.$slots.stepper);
        },
        hasIntroNav() {
            return !!(this.$slots.intronav);
        },
        hasStepper() {
            return !!(this.$slots.stepper);
        },
        hasProducerOptions() {
            return !!(this.$slots.produceroptions);
        },
        mainClass() {
            return this.displayMode ? 'main--' + this.displayMode : null;
        }
    },
    mounted() {
        this.$language.current = window._locale;
    },
    updated() {
        this.$language.current = window._locale;
    },
};
</script>
